import * as i0 from '@angular/core';
import { Input, Component, NgModule } from '@angular/core';
import { isMobile } from '@engineering11/web-utilities';
import * as i1 from 'angularx-qrcode';
import { QRCodeModule } from 'angularx-qrcode';
import { CommonModule } from '@angular/common';

class E11QrCodeComponent {
    constructor() {
        this.margin = 1;
        this.width = 180;
        this.mobileWidth = 120;
        this.label = '';
        this.title = '';
        this.isMobile = isMobile();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11QrCodeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11QrCodeComponent, selector: "e11-qrcode", inputs: { value: "value", margin: "margin", width: "width", mobileWidth: "mobileWidth", label: "label", title: "title" }, ngImport: i0, template: `
    <qrcode
      [qrdata]="value"
      [errorCorrectionLevel]="'M'"
      [width]="isMobile ? mobileWidth : width"
      [ariaLabel]="label"
      [margin]="margin"
      [title]="title"
      [cssClass]="'e11-qrcode'"
    >
    </qrcode>
  `, isInline: true, dependencies: [{ kind: "component", type: i1.QRCodeComponent, selector: "qrcode", inputs: ["allowEmptyString", "colorDark", "colorLight", "cssClass", "elementType", "errorCorrectionLevel", "imageSrc", "imageHeight", "imageWidth", "margin", "qrdata", "scale", "version", "width", "alt", "ariaLabel", "title"], outputs: ["qrCodeURL"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11QrCodeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-qrcode', template: `
    <qrcode
      [qrdata]="value"
      [errorCorrectionLevel]="'M'"
      [width]="isMobile ? mobileWidth : width"
      [ariaLabel]="label"
      [margin]="margin"
      [title]="title"
      [cssClass]="'e11-qrcode'"
    >
    </qrcode>
  ` }]
        }], ctorParameters: () => [], propDecorators: { value: [{
                type: Input,
                args: [{ required: true }]
            }], margin: [{
                type: Input
            }], width: [{
                type: Input
            }], mobileWidth: [{
                type: Input
            }], label: [{
                type: Input
            }], title: [{
                type: Input
            }] } });

class E11QrcodeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11QrcodeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11QrcodeModule, declarations: [E11QrCodeComponent], imports: [CommonModule, QRCodeModule], exports: [E11QrCodeComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11QrcodeModule, imports: [CommonModule, QRCodeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11QrcodeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11QrCodeComponent],
                    imports: [CommonModule, QRCodeModule],
                    exports: [E11QrCodeComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11QrCodeComponent, E11QrcodeModule };
